export default "__VITE_ASSET__5ad5ec85__"